import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { APP_MODALS } from "./constant";
import type { ModalState, TModalsIds } from "./types";
import { TEntityInfo } from "../../../common/types/utility";

const initialState: ModalState = {
  appModals: APP_MODALS,
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    updateModal: (
      state,
      action: PayloadAction<{
        id: TModalsIds;
        info: TEntityInfo | null;
        isOpen: boolean;
        subtype?: string;
      }>,
    ) => {
      const { id, info, isOpen, subtype } = action.payload;
      if (!id) return;
      state.appModals[id].info = info;
      state.appModals[id].isOpen = isOpen;
      state.appModals[id].subtype = subtype;
    },
  },
});

export const modalReducers = modalSlice.reducer;
export const { updateModal } = modalSlice.actions;
